// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"830af2ca","368":"c7a7dfb9","427":"76af8161","783":"32e98b2a","806":"76af8161","967":"a312e4b2","994":"c00c0381"}[chunkId] + ".chunk.css";
};